/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const Dispatcher: React.FC<Props> = ({ color = '#000000', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="2.75"
      y="2.75"
      width="18.5003"
      height="6.70014"
      rx="2.05005"
      stroke={props.style?.color || color}
      strokeWidth="1.5"
    />
    <path
      d="M6.19466 8.7998C6.19466 10.7925 5.51867 15.1764 6.96717 16.7705C8.45703 18.5639 12.7612 17.8665 13.4372 17.8665"
      stroke={props.style?.color || color}
      strokeWidth="1.5"
    />
    <rect
      x="12.75"
      y="14.5498"
      width="8.50017"
      height="6.70014"
      rx="2.05005"
      stroke={props.style?.color || color}
      strokeWidth="1.5"
    />
  </svg>
);

export default Dispatcher;
